export default __webpack_public_path__ + "static/media/marian_dover.d38b2418.jpg";